import { useEffect } from "react";

const LanguageSelector = ({ languages }) => {
  const languagesArray = languages?.length > 0 ? languages : ["en"];

  const languagesString = languagesArray.join(",");
  let includedLanguages = languagesString;

  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        includedLanguages: includedLanguages,
        autoDisplay: true,
      },
      "google_translate_element"
    );
  };

  useEffect(() => {
    if (languages) {
      var googleTranslator = document.getElementById(
        "google-translator-script"
      );
      if (!googleTranslator) {
        var addScript = document.createElement("script");
        addScript.setAttribute(
          "src",
          "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        );
        addScript.setAttribute("id", "google-translator-script");
        document.body.appendChild(addScript);
        window.googleTranslateElementInit = googleTranslateElementInit;
      }
    }
  }, [languages]);

  return null;
};

export default LanguageSelector;
